// Copyright 2025, University of Maryland, All Rights Reserved
import {
  createApiClient,
  handleApiError,
  sanitizeResponseData,
} from '@umd-dit-ai-workspace/api-client';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

// Create the shared API client instance
const apiClient = createApiClient({
  baseURL: API_BASE_URL,
  debug: import.meta.env.NODE_ENV === 'development'
});

// Export the axios instance for compatibility
export const axiosInstance = apiClient.getAxiosInstance();

// Re-export shared utilities
export { handleApiError, sanitizeResponseData};

// Export the API client instance
export { apiClient };